module.exports = __webpack_public_path__ + "static/media/500_homes_delivered.ea7e3441.svg";